import React from "react";
import Profile from "../components/Profile";

const About = () => {
  return (
    <div className="textStyle">
      <div>
        <h2>About</h2>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin
          imperdiet euismod imperdiet. Praesent congue, est eget commodo
          ullamcorper, justo lorem dictum lacus, id mollis odio neque ut nulla.
          Morbi neque nisi, blandit eget velit sit amet, dictum laoreet massa.
          Aliquam erat volutpat. Aliquam et felis vitae tellus pulvinar
          sollicitudin eu in magna. Donec ex elit, efficitur eu sapien sagittis,
          cursus lacinia dolor. Sed sollicitudin, nisi aliquet pulvinar
          elementum, justo nulla consectetur ipsum, sit amet dignissim est ex
          non felis. Quisque euismod nibh libero, id ultricies urna facilisis
          mattis. Sed turpis augue, commodo vel diam et, ultricies aliquam
          dolor. Cras quis suscipit dui. Etiam malesuada suscipit felis, sit
          amet rhoncus elit porta vitae. Sed vel leo eu metus consequat egestas.
          Maecenas dapibus porttitor nunc eget lobortis. Phasellus ut lorem eget
          tortor commodo viverra a et turpis. Mauris eu elit vitae tortor porta
          gravida et at sem. Curabitur mollis lobortis neque ac laoreet.
          Pellentesque eget ligula mollis, porttitor dolor quis, consequat
          justo. Integer sagittis nibh vitae accumsan consequat. Nunc hendrerit,
          tortor a egestas ornare, mi nisi varius metus, eu tempor lorem arcu
          vel velit. Fusce nec velit felis. Aliquam erat volutpat. Suspendisse
          potenti. Suspendisse placerat arcu vel nulla consectetur, eu ultricies
          ligula rhoncus. Nullam dolor odio, accumsan et fringilla placerat,
          consequat ac metus. Nam auctor nunc sed eleifend maximus. Proin
          porttitor turpis arcu, ut porttitor erat dictum id. Vivamus eget metus
          a justo pulvinar cursus nec at augue. Sed purus purus, tincidunt eget
          ultricies non, euismod sit amet metus. Fusce ut rhoncus nulla, sed
          dictum tortor. Nulla purus nisi, blandit quis fermentum a, laoreet sed
          velit. Integer euismod enim eget faucibus mollis. Maecenas in risus
          pulvinar, blandit libero a, lobortis arcu. Vivamus mattis metus eu
          quam aliquam volutpat. Curabitur nec ligula vulputate, facilisis leo
          in, placerat lacus. Ut suscipit porttitor elit, sed convallis libero
          lacinia et. Suspendisse dictum lectus sit amet ex semper aliquet.
          Donec facilisis interdum tellus, at vestibulum turpis gravida non.
          Quisque maximus eget arcu ut porttitor. Quisque nisi leo, lacinia id
          lectus ac, varius mattis mauris. Etiam maximus et sapien eu bibendum.
          Sed urna magna, tincidunt sed dignissim eu, malesuada id arcu. Ut eu
          lorem sed elit malesuada imperdiet in non diam. Praesent condimentum
          suscipit scelerisque. Vestibulum mi diam, imperdiet non hendrerit sit
          amet, rutrum sit amet urna. Suspendisse potenti. Maecenas sit amet
          massa eget erat molestie fermentum pharetra ut neque. Aliquam et dui
          at massa varius lacinia. Aliquam erat volutpat. Maecenas congue
          vestibulum arcu ac tempor. Vestibulum vitae aliquet justo, at finibus
          sem. Praesent non dignissim felis, in mattis tellus. Vestibulum
          egestas laoreet lorem viverra interdum. Pellentesque congue orci non
          cursus ultricies. In hendrerit urna in tincidunt placerat. Ut semper
          vulputate turpis id aliquam. Donec mattis sapien eu purus pharetra
          facilisis. Sed est turpis, commodo finibus egestas ut, rutrum non
          arcu. Nulla iaculis ultricies urna ut consectetur. Morbi mi leo,
          condimentum quis congue vel, semper vel nibh. Suspendisse sit amet leo
          ante. Etiam accumsan velit ac mauris suscipit finibus. Etiam tincidunt
          ante sed lectus varius, euismod commodo leo egestas. Suspendisse
          potenti. Cras ex diam, porttitor sit amet convallis sed, mattis id
          ante. Suspendisse massa magna, commodo at lectus in, fringilla ornare
          turpis. Nulla facilisi. Donec rhoncus placerat lorem, eget elementum
          tellus venenatis id. Curabitur ultricies diam quis sollicitudin
          condimentum. Curabitur bibendum gravida urna sit amet commodo. Integer
          eget nulla at metus ultrices commodo. Duis a molestie sapien. Nunc
          gravida enim bibendum sapien dictum euismod non in est. Nam sagittis
          ornare ultricies. Phasellus accumsan felis nisl, vel tincidunt turpis
          vulputate sed. Proin in sollicitudin augue. Quisque arcu lacus, luctus
          id neque id, elementum pharetra quam. Sed dictum, odio sed dignissim
          convallis, enim massa scelerisque diam, a semper purus leo ut elit.
          Aenean lobortis, nulla ut finibus vehicula, enim nulla scelerisque
          augue, non finibus risus erat at urna. Donec urna neque, lobortis sit
          amet orci quis, hendrerit aliquam mi. Sed id quam et ligula ultrices
          mattis ac sit amet nulla. Orci varius natoque penatibus et magnis dis
          parturient montes, nascetur ridiculus mus. Duis dui lorem, dictum ut
          malesuada sed, cursus eu turpis. Vivamus semper arcu id efficitur
          blandit. Nullam hendrerit lacinia arcu, molestie ornare lacus
          dignissim eget. Ut sem eros, ultricies vel semper in, bibendum at
          tellus. Integer sollicitudin ultricies eleifend. Curabitur dignissim
          justo est, et placerat dolor viverra sit amet. Quisque vitae sapien et
          lorem molestie accumsan non sed dolor. Vivamus imperdiet sapien lacus,
          in scelerisque leo fringilla sed. Pellentesque risus nisi, congue et
          justo ac, facilisis volutpat tellus. Proin mattis neque nec
          consectetur tincidunt. Proin gravida lobortis nisl eget tristique.
          Mauris non placerat massa. Phasellus iaculis, felis nec rutrum
          fringilla, tortor enim porttitor arcu, et ullamcorper lacus nibh a
          felis. Class aptent taciti sociosqu ad litora torquent per conubia
          nostra, per inceptos himenaeos. Cras fringilla dapibus velit, vel
          tincidunt magna facilisis sit amet. Nunc lectus nibh, lobortis ac
          tincidunt in, lobortis a felis. Cras pharetra id velit eget commodo.
          Aliquam eget finibus est, a mattis sem. Donec eget fermentum augue.
          Vivamus ac consequat risus. Vestibulum aliquam enim nec massa pulvinar
          luctus. Suspendisse congue euismod sapien eu volutpat. Duis a lorem
          porttitor, cursus lorem sit amet, aliquam massa. Ut sagittis risus
          egestas purus mollis, id fringilla est pharetra. Maecenas efficitur
          nibh quis fringilla iaculis. Donec ultrices risus mi, vel laoreet erat
          blandit eget. Sed mattis consectetur consequat. Etiam lacinia a magna
          et venenatis. Etiam ornare, odio nec interdum ornare, tortor eros
          venenatis enim, nec volutpat justo ligula quis ligula. In pellentesque
          consequat enim, eu maximus neque. Nullam a laoreet massa. Class aptent
          taciti sociosqu ad litora torquent per conubia nostra, per inceptos
          himenaeos. Nunc consectetur sapien ac lacus molestie, quis sagittis
          nisl accumsan. Phasellus fringilla lectus a turpis rhoncus placerat.
          Phasellus ut commodo nisi. Phasellus leo neque, sollicitudin elementum
          dapibus a, fringilla ut sem. Morbi neque eros, tempor placerat tempor
          sed, suscipit vitae arcu. Vestibulum nunc purus, consequat a nibh ut,
          suscipit finibus neque. Vivamus eget ornare augue. In hac habitasse
          platea dictumst. Nunc id consequat lectus. Pellentesque vel mi
          euismod, dapibus eros a, dapibus libero. Phasellus tincidunt, nisl
          vitae lobortis consectetur, massa metus porttitor felis, a fringilla
          erat eros nec augue. Pellentesque consequat faucibus magna, ut varius
          velit venenatis vel. Vivamus condimentum nec felis vel vehicula.
          Praesent velit massa, posuere in auctor eu, dapibus vel nibh. Donec
          mattis ex in porttitor ultricies. In cursus porta rutrum. Maecenas ac
          velit volutpat, tincidunt risus et, auctor urna. Duis viverra arcu
          enim, eget tempor enim maximus vel. In sapien felis, accumsan at dui
          sodales, sagittis ornare quam. Donec nec viverra dui, venenatis
          posuere eros. Cras finibus vehicula leo quis scelerisque. Cras a felis
          auctor, consequat elit et, dapibus lorem. Phasellus eu lorem vitae
          quam dignissim porttitor. Phasellus tincidunt ultricies orci vitae
          ullamcorper. Vestibulum porta dapibus diam, pretium congue enim
          commodo ac. Phasellus semper, mauris in gravida blandit, magna mauris
          pretium lectus, non tristique velit lorem ut lacus. Vivamus placerat
          lacus vel magna pellentesque interdum. Ut iaculis scelerisque nibh.
          Etiam cursus magna et arcu sodales pharetra. Cras fringilla eu ipsum
          et tincidunt. Sed laoreet volutpat nunc, nec ornare felis porta id.
          Praesent risus neque, finibus vel arcu sit amet, laoreet tincidunt
          quam. Etiam velit metus, interdum ac suscipit eu, varius vitae enim.
          Suspendisse fringilla molestie rutrum. Duis blandit nisi nec velit
          lobortis, id efficitur mi volutpat. Curabitur sodales, urna eleifend
          pulvinar gravida, augue metus tincidunt odio, id facilisis nisl odio a
          mi. Curabitur condimentum feugiat sapien, vel ullamcorper nisl egestas
          eget. Mauris varius sit amet tellus nec lacinia. Suspendisse et
          porttitor est. Morbi tristique aliquet nisi vitae dapibus. In hac
          habitasse platea dictumst. Etiam sit amet ex metus. In elementum ut
          tortor a auctor. Praesent ut hendrerit lacus. Nullam pretium neque
          lectus, ac ultricies lacus iaculis sit amet. Phasellus venenatis,
          lorem nec aliquet tincidunt, purus eros lacinia magna, sit amet
          dapibus eros ante eu nibh. Morbi non nibh sagittis, tempus velit
          euismod, hendrerit tortor. Nulla in ex sit amet nibh commodo aliquam
          in sed ligula. Phasellus id feugiat sapien. Fusce maximus, leo a
          ultrices sagittis, urna lacus ultricies purus, ac tristique felis nisi
          vitae erat. Ut fermentum nunc sed neque tempus, sit amet tristique
          orci iaculis. Nam laoreet rutrum eros porta cursus. Donec quis mauris
          est. Vestibulum quis augue commodo, sodales nunc nec, tristique
          ligula. Morbi porta dui pretium, vestibulum ex at, tincidunt urna.
        </p>
        <Profile />
      </div>
    </div>
  );
};
export default About;
